import { css } from '@/styled-system/css';

export const trustSignalText = css({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  margin: 0,
  color: 'hpxGrey600',
  fontSize: 'tiny',
  lineHeight: '16px',
  letterSpacing: '0.3px',
  md: {
    fontSize: '13px',
    lineHeight: '18px',
  },
});

export const trustSignalSegment = css({
  display: 'flex',
  alignItems: 'center',
});

export const trustSignalSeparator = css({
  color: 'hpxGrey400',
  marginX: '6px',
});
